import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCallback, useEffect } from 'react'
import { HicIconButton } from 'src/app/components/hic-vapor/button/icon-button'

type PageHeaderItemProps = {
  text: string
  start?: Date
  end?: Date
  customerId?: string
  companyId?: string
  note?: string
  onInitialValuesRetrieved: (start: Date, end: Date, customerId?: string, companyId?: string, note?: string) => void
  onButtonClick: () => void
  icon?: IconProp
}

const startKey = 'reservation-insert-start'
const endKey = 'reservation-insert-end'
const customerIdKey = 'reservation-insert-customer-id'
const companyIdKey = 'reservation-insert-company-id'
const noteKey = 'reservation-note-end'

export default function ReservationInsertPageHeaderItem({ text, start, end, customerId, companyId, note, onInitialValuesRetrieved, onButtonClick, icon }: PageHeaderItemProps) {
  const storeValue = useCallback(() => {
    if (start) sessionStorage.setItem(startKey, String(start.getTime()))
    if (end) sessionStorage.setItem(endKey, String(end.getTime()))
    if (customerId) sessionStorage.setItem(customerIdKey, customerId)
    if (companyId) sessionStorage.setItem(companyIdKey, companyId)

    if (note) sessionStorage.setItem(noteKey, note)
  }, [start, end, customerId, companyId, note])

  const clearStoredValues = useCallback(() => {
    sessionStorage.removeItem(startKey)
    sessionStorage.removeItem(endKey)
    sessionStorage.removeItem(customerIdKey)
    sessionStorage.removeItem(companyIdKey)
    sessionStorage.removeItem(noteKey)
  }, [])

  useEffect(() => {
    const startValue = sessionStorage.getItem(startKey) ?? undefined
    const endValue = sessionStorage.getItem(endKey) ?? undefined
    const customerIdValue = sessionStorage.getItem(customerIdKey) ?? undefined
    const companyIdValue = sessionStorage.getItem(companyIdKey) ?? undefined
    const noteValue = sessionStorage.getItem(noteKey) ?? undefined
    if (startValue && endValue && !isNaN(Number(startValue)) && !isNaN(Number(endValue))) {
      onInitialValuesRetrieved(new Date(Number(startValue)), new Date(Number(endValue)), customerIdValue, companyIdValue, noteValue)
    }
    clearStoredValues()
  }, [onInitialValuesRetrieved])

  return (
    <HicIconButton
      size={/* md ? 'medium' :  */ 'small'}
      variant="outlined"
      sx={{ marginLeft: 2 }}
      onClick={() => {
        storeValue()
        onButtonClick()
      }}
      startIcon={icon ? <FontAwesomeIcon icon={icon} /> : undefined}
    >
      {text}
    </HicIconButton>
  )
}
